import 'bootstrap/dist/css/bootstrap.css';
import React from 'react';
import ReactDOM from 'react-dom';
import 'bootstrap/dist/css/bootstrap.min.css'; 
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');

const baseUrlNew = baseUrl;
ReactDOM.render(
    <BrowserRouter basename={baseUrlNew}>
        <App />
  </BrowserRouter>,
  rootElement);

registerServiceWorker();
